import { EComparisonStatus } from '../../types/newbuildingHeader';

export const SetNewbuildingComparisonStatusActionType = 'newbuildingInformation/SET_COMPARISON_STATUS';

export interface ISetNewbuildingComparisonStatusAction {
  type: typeof SetNewbuildingComparisonStatusActionType;
  comparisonStatus: EComparisonStatus;
}

export type TNewbuildingInformationActions = ISetNewbuildingComparisonStatusAction;

export function setNewbuildingComparisonStatus(
  comparisonStatus: EComparisonStatus,
): ISetNewbuildingComparisonStatusAction {
  return {
    type: SetNewbuildingComparisonStatusActionType,
    comparisonStatus,
  };
}
